import i18n from 'i18next';
import { Region } from 'react-native-maps';
import { City, useCityParkingStore } from 'stores/cityParkingStore';
import {
  CountryCode,
  Customer,
  Maybe,
  Pricing,
  StrongAuthentication,
} from 'types/generatedSchemaTypes';
import { currencyFormatter, getValidPrice } from './commonUtils';

export type CityViewScreenAction = 'IDENTIFY' | 'BUY_PERMIT' | 'APPLY_PERMIT';

export const hasAuthenticated = (customer: Customer) => {
  return Boolean(customer?.strongAuthentication?.gedi);
};

export const getInitialRegion = (city: City): Region | undefined => {
  if (city === 'Turku') {
    return {
      latitude: 60.45,
      longitude: 22.268,
      latitudeDelta: 0.06,
      longitudeDelta: 0.06,
    };
  }
};

export const getCities = (city: City) => {
  if (city === 'Turku') {
    return ['Turku', 'Åbo'];
  }
};

export const getMarkerLetter = (name?: Maybe<string>) => {
  const city = useCityParkingStore.getState().byMemberGroupSearchParams.city;
  if (city === 'Turku') {
    return name?.match(/.(?=-alue$)/)?.find(Boolean);
  }
};

export const getCityViewScreenAction = (
  customer: Customer
): CityViewScreenAction | undefined => {
  if (!hasAuthenticated(customer)) {
    return 'IDENTIFY';
  }
  const pmc = useCityParkingStore.getState().selectedPmc;
  if (
    customer?.householdBenefits?.some(
      (benefit) => benefit.benefitTargetUid === pmc?.pmcId
    )
  ) {
    return 'BUY_PERMIT';
  }
  if (pmc) {
    return 'APPLY_PERMIT';
  }
};

export const getMonthlyPrice = (
  prices: Maybe<Pricing[]> | undefined,
  countryCode: CountryCode | undefined,
  startDate?: Date
) => {
  if (!prices || prices?.length === 0) {
    return i18n.t('price.noPrice');
  }
  const validPrice = getValidPrice(prices, startDate);
  if (validPrice?.monthlyPrice) {
    const price = currencyFormatter(
      validPrice?.monthlyPrice / 100,
      countryCode
    );
    return i18n.t('price.monthlyPrice', { price });
  }
  return i18n.t('price.noPrice');
};

export const getCustomerAddress = (
  strongAuth: Maybe<StrongAuthentication> | undefined
) => {
  const address = strongAuth?.addresses?.find(Boolean);
  if (address) {
    return `${address.streetName} ${address.streetNumber}`;
  }
};
